import { useState, useEffect } from "react";

const useInvoke = (db, sp, params) => {

    const [data, setData] = useState([]);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);

    const target = "https://api.cssi.co/query";
    const server = "Compass-Svr3\\EXACTSQLEXPRESS";
    //const db = "WebApps";

    useEffect(() => {

        const abortRequest = new AbortController();

        // const testificate = {
        //     "sp": "pr_AdminGetAllUSers", 
        //     "parameters": {"@Active": 1, "@Disabled": 0},
        //     "servername": "Compass-Svr3\\EXACTSQLEXPRESS", 
        //     "databasename": "WebApps", 
        //     "continuingfunction": null,
        //     "noresults": false, 
        //     "args": null
        //     };

        let postObj = {
            "sp": sp,
            "parameters": params,
            "servername": server,
            "databasename": db,
            "continuingfunction": null,
            "noresults": false,
            "args": null
        };

        fetch(target, {
            method: "POST",
            body: JSON.stringify(postObj),
            signal: abortRequest.signal

        })
            .then(response => {

                if (!response.ok) {
                    console.log(response);
                    throw Error(`No resource found at ${target}`);
                }
                return response.json();
            })
            .then((data) => {

                //console.log(data);
                setData(data);
                setIsPending(false);
                setError(null);

            })
            .catch(e => {
                if (e.name === "AbortError") {
                    console.log("Fetch Aborted");
                }

                else {
                    setError(e.message);
                    setIsPending(false);
                }

            })

        //return () => console.log("Cleanup");
        return () => abortRequest.abort();

    }, [target]);

    return { data, isPending, error };
}

export default useInvoke;